// extracted by mini-css-extract-plugin
export default {"notifications":"NotificationSettings_notifications__mfQ-J"};